<template>
  <div>
    <!-- editing business role -->
    <div class="modal fade" id="mod-edit-role" role="dialog">
      <div
        class="modal-dialog m-0 p-0 fixed overflow-y-scroll top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] p-[40px] md:min-h-screen"
        >
          <div
            class="modal-header modal-header-colored flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Editing Distributor Manager Role
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div>
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Role Name</label
              >
              <div>
                <input
                  :class="[{ 'is-invalid': v2.name }]"
                  type="text"
                  v-model="updateRole.name"
                  class="bg-[[#fcfcfd]] border-[##96a0b5] border-solid border-[1.5px] py-[14px] px-[16px] md:px-[24px] rounded-[8px] text-[14px] md:text-[16px] font-medium leading-[20px] w-full"
                  placeholder="Enter role name"
                />
                <ul v-if="v2.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <div class="mt-[16px]">
              <div>
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Permissions</label
                >
                <div
                  class="bg-white w-full"
                  style="height: 380px; overflow-y: scroll;"
                >
                  <ol class="flex flex-col gap-[5px] w-full">
                    <li v-for="item in permissionsListUpdate" :key="item.id">
                      <div
                        class="flex items-center justify-between gap-[5px] py-[14px] px-[10px] border-b border-[#eee] cursor-pointer"
                        @click="item.state.opened = !item.state.opened"
                      >
                        <input
                          type="checkbox"
                          :disabled="item.state.disabled"
                          :name="item.text"
                          :checked="item.state.selected"
                          class="custom-checkbox"
                          @click.stop="
                            item.state.selected = !item.state.selected
                          "
                          @change="
                            onPermissionChange(item, item.state.selected)
                          "
                        />
                        <label
                          :for="item.text"
                          class="text-[#353535] font-medium text-[16px] m-0 w-full"
                          >{{ item.text }}</label
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-[#353535] transition-transform duration-300"
                          :class="item.state.opened ? 'rotate-180' : 'rotate-0'"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                      <ol v-if="item.children.length != 0 && item.state.opened">
                        <li
                          v-for="children in item.children"
                          :data-id="children.id"
                          class="border-b border-[#eee] w-full py-[11px]"
                          :key="children.id"
                        >
                          <div class="px-[28px] flex items-center gap-[8px]">
                            <input
                              type="checkbox"
                              :name="children.text"
                              :checked="children.state.selected"
                              :disabled="children.state.disabled"
                              class="custom-checkbox"
                              @click="
                                children.state.selected = !children.state
                                  .selected
                              "
                            />
                            <label
                              :for="children.text"
                              class="text-[#353535] font-normal text-[14px] m-0 w-full"
                              >{{ children.text }}</label
                            >
                          </div>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              type="button"
              data-dismiss="modal"
              :disabled="isBusyModal"
              @click="cancel"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="update"
            >
              {{ isBusyModal ? "Loading..." : "Update" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import Pagination from "../Pagination.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "BusinessRole",
  components: {
    Select2,
    Pagination,
  },
  props: ["editRoles", "businessEdit"],
  data() {
    return {
      isBusy: false,
      isBusyModal: false,
      createRole: {
        name: null,
        permissions: [],
      },
      updateRole: {
        name: null,
        id: null,
        permissions: [],
      },
      v1: {
        name: false,
        accessRights: false,
        managerAccessRights: false,
      },
      v2: {
        name: false,
        accessRights: false,
        managerAccessRights: false,
      },
      permissions: [],
      count: 0,
      page: 0,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
    };
  },
  created() {},
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    permissionsListCreate() {
      return this.createRole.permissions.map((b) => {
        return b;
      });
    },
    permissionsListUpdate() {
      if (!this.editRoles.permissions) {
        return this.createRole.permissions.map((b) => {
          return b;
        });
      }
      this.updateRole = this.editRoles;
      return this.editRoles.permissions.map((b) => {
        return b;
      });
    },
  },
  methods: {
    onPermissionChange(item, state) {
      for (let child of item.children) {
        child.state.selected = state;
      }
    },
    reset() {
      this.filter = {
        status: "0",
        qry: "",
      };
    },
    cancel() {
      $("#mod-edit-role").modal("hide");
    },

    viewExport() {
      //   $("#mod-export").modal("show");
    },
    viewAdd() {
      this.createRole = {
        name: null,
        permissions: JSON.parse(JSON.stringify(this.permissions)),
      };
      this.v1 = {
        name: false,
      };
      $("#mod-add-business").modal("show");
    },
    viewEdit(c) {
      var editValues = {
        name: c.roleName,
        id: c.id,
        permissions: JSON.parse(JSON.stringify(c.permissions)),
      };
      this.editRole = editValues;

      this.updateRole = {
        id: c.id,
        name: c.roleName,
        permissions: JSON.parse(JSON.stringify(c.permissions)),
      };

      $("#mod-edit-role").modal("show");
    },
    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      const data = {
        name: this.updateRole.name,
        permissions: this.updateRole.permissions,
        roleId: this.updateRole.id,
        parentId: this.user.parentId,
      };

      if (this.validateUpdate()) {
        await this.$http
          .put("/Roles/update/" + data.roleId, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.$toast.success("Updated successfully.", {
              icon: true,
              rtl: false,
            });
            this.$emit("roleComplete");
          })
          .catch(function(err) {});
        this.getRoles();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateUpdate() {
      this.v2 = {
        name: false,
      };
      var isValid = true;

      if (!this.updateRole.name) {
        this.v2.name = true;
        isValid = false;
      }

      return isValid;
    },
    async getRoles() {
      this.isBusy = true;

      await this.$http
        .get(
          "/Roles/getRoleList?page=" +
            this.page +
            "&pageSize=" +
            this.pageSize +
            "&roleType=" +
            this.user.type +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "")
        )
        .then(function(res) {
          this.roles = res.body.data;
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
        })
        .catch(function() {});

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },
    async getPermissions() {
      this.isBusy = true;

      await this.$http
        .get("/Roles/getPermissionList?roleType=" + this.user.type)
        .then(function(res) {
          this.permissions = res.body;
          this.createRole.name = "";
          this.createRole.permissions = this.permissions;
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
        })
        .catch(function() {});

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    formatDate(date) {
      return moment(date).format("lll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    prev() {
      this.page -= 1;
      this.getRoles();
    },

    next() {
      this.page += 1;
      this.getRoles();
    },

    gotoPage(page) {
      this.page = page - 1;
      this.getRoles();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getRoles();
    },
  },
};
</script>
<style scoped>
.custom-checkbox {
  width: 24px;
  height: 18.9px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
</style>
